import { useState, useEffect } from "react";
import api from "../../services/api";
import { Link } from "react-router-dom";
import './home.css'


function Home(){

    const [filmes, setFilmes] = useState([])
    const [load, setLoad] = useState(true)
    useEffect(()=>{
    async function loadFilmes(){
      const response = await api.get("movie/now_playing", {
        params: {
            api_key: "2702faf1ee37ee08fe6c848f89772099",
            language: "pt-BR",
            page: 1
        }
      })

     // console.log(response.data.results.slice(0,10));
     setFilmes(response.data.results.slice(0,20))
     }

     loadFilmes()
     setLoad(false)
    }, [])

    if(load){
        return(
            <div>
                <h2>Carregando...</h2>
            </div>
        )
    }
    return(
        <div className="container">
             <h1 className="texto">Filmes em Cartaz</h1>
            <div className="lista-filmes">
             {filmes.map((filme)=>{
                return(
                    <article key={filme.id} className="card">
                        <strong>{filme.title}</strong>
                        <img src={`https://image.tmdb.org/t/p/original/${filme.poster_path}`}alt={filme.title}></img>
                        <Link className="btn" to={`/filme/${filme.id}`}>Acessar</Link>
                    </article>
                )
             })}
            </div>
        </div>
    )

}

export default Home;

